module.exports = __webpack_public_path__ + "img/product28804b.02f57ca2.png";